import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_CAN_ADD_EVENT,
    CLEAR_CAN_ADD_EVENT_ERROR,
    LOAD_CAN_ADD_EVENT_REQUEST,
    LOAD_CAN_ADD_EVENT_SUCCESS,
    LOAD_CAN_ADD_EVENT_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_CAN_ADD_EVENT,
    CLEAR_ERROR: CLEAR_CAN_ADD_EVENT_ERROR,
    LOAD_REQUEST: LOAD_CAN_ADD_EVENT_REQUEST,
    LOAD_SUCCESS: LOAD_CAN_ADD_EVENT_SUCCESS,
    LOAD_FAILURE: LOAD_CAN_ADD_EVENT_FAILURE
}